import { render, staticRenderFns } from "./StaffSettings.vue?vue&type=template&id=4f6b75f6&scoped=true&"
import script from "./StaffSettings.vue?vue&type=script&lang=js&"
export * from "./StaffSettings.vue?vue&type=script&lang=js&"
import style0 from "./StaffSettings.vue?vue&type=style&index=0&id=4f6b75f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b75f6",
  null
  
)

export default component.exports